"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionSet = void 0;
var _Permissions = require("./Permissions.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PermissionSet = exports.PermissionSet = /*#__PURE__*/function () {
  function PermissionSet() {
    _classCallCheck(this, PermissionSet);
  }
  return _createClass(PermissionSet, null, [{
    key: "getPermissionsArray",
    value:
    /**
     * Returns an array of the Permission names for the permission bits
     */
    function getPermissionsArray(permissionBits) {
      if (!permissionBits) return [];
      var bits = BigInt(permissionBits);
      var permissionNames = [];
      Object.keys(_Permissions.Permissions).forEach(function (key) {
        var mask = BigInt(1) << BigInt(_Permissions.Permissions[key]);
        var hasPermission = (bits & mask) > BigInt(0);
        if (hasPermission) permissionNames.push(key);
      });
      return permissionNames;
    }

    /**
     * Given a Permission, sets the permission bit as well as those from inherited permissions
     */
  }, {
    key: "setPermission",
    value: function setPermission(permissionBits, permissionName) {
      var inheritedToAdd = [];
      var inheritedPermissionArray = _Permissions.InheritedPermissions[permissionName];
      var _iterator = _createForOfIteratorHelper(inheritedPermissionArray),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var iPermName = _step.value;
          inheritedToAdd.push(iPermName);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var allPermissionsToSet = inheritedToAdd.concat(permissionName); //create an array of the passed permissionName plus our inherited ones
      var _iterator2 = _createForOfIteratorHelper(allPermissionsToSet),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _permissionName = _step2.value;
          var opBit = BigInt(1) << BigInt(_Permissions.Permissions[_permissionName]);
          permissionBits |= opBit;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return permissionBits;
    }

    /**
     * Given a Permission, clears the permission bit, and also any that inherit the permission
     */
  }, {
    key: "clearPermission",
    value: function clearPermission(permissionBits, permissionName) {
      var inheritorsToRemove = [];
      Object.keys(_Permissions.InheritedPermissions).forEach(function (key) {
        var inheritedArray = _Permissions.InheritedPermissions[key];
        var _iterator3 = _createForOfIteratorHelper(inheritedArray),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var iPermName = _step3.value;
            if (iPermName === permissionName) inheritorsToRemove.push(key);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
      var allPermissionsToClear = inheritorsToRemove.concat(permissionName); //create an array of the passed permissionName plus our inheritors
      var _iterator4 = _createForOfIteratorHelper(allPermissionsToClear),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _permissionName2 = _step4.value;
          var opBit = BigInt(1) << BigInt(_Permissions.Permissions[_permissionName2]);
          permissionBits &= ~opBit;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return permissionBits;
    }
  }, {
    key: "defaultPermissionsForRole",
    value: function defaultPermissionsForRole(roleKey) {
      var permissionBits = BigInt(0); // start cleared
      var _iterator5 = _createForOfIteratorHelper(_Permissions.DefaultPermissions[roleKey]),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var perm = _step5.value;
          // add each default permission
          permissionBits = PermissionSet.setPermission(permissionBits, perm);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return permissionBits;
    }
  }]);
}();